module.exports = __webpack_public_path__ + "static/media/jbl-speaker.66807511.png";